import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-8e1bdcb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "skills",
  class: "mb-16"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Habilidades", -1))
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-2 gap-x-14 gap-y-10" }
const _hoisted_4 = { class: "font-mono-label text-xs uppercase tracking-[0.14em] text-subtle mb-4" }
const _hoisted_5 = { class: "space-y-4" }
const _hoisted_6 = { class: "flex justify-between items-baseline mb-1" }
const _hoisted_7 = { class: "text-sm font-semibold text-ink" }
const _hoisted_8 = { class: "font-mono-label text-[0.7rem] text-subtle" }
const _hoisted_9 = { class: "h-px bg-hairline relative" }

import { ref } from 'vue';

interface Skill {
  name: string;
  nivel: string;
  pct: number;
}

interface Grupo {
  titulo: string;
  skills: Skill[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Habilidades',
  setup(__props) {

const grupos = ref<Grupo[]>([
  {
    titulo: 'Backend',
    skills: [
      { name: 'Java (8/11, practicando 17)', nivel: 'Profesional', pct: 85 },
      { name: 'Spring Boot / REST APIs / Maven', nivel: 'Intermedio', pct: 80 },
      { name: 'SQL (PostgreSQL, MySQL, Oracle)', nivel: 'Intermedio', pct: 70 },
      { name: 'SOAP & JMS/MQ', nivel: 'Básico', pct: 55 },
      { name: 'AWS S3 & GitHub Actions CI/CD', nivel: 'Intermedio', pct: 65 },
      { name: 'Docker', nivel: 'Básico', pct: 50 },
    ],
  },
  {
    titulo: 'Frontend',
    skills: [
      { name: 'HTML5 / CSS3', nivel: 'Intermedio', pct: 75 },
      { name: 'JavaScript / TypeScript', nivel: 'Intermedio', pct: 65 },
      { name: 'Vue.js', nivel: 'Básico', pct: 55 },
      { name: 'Angular', nivel: 'Básico', pct: 55 },
      { name: 'NestJS', nivel: 'Básico', pct: 40 },
    ],
  },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grupos.value, (grupo) => {
        return (_openBlock(), _createElementBlock("div", {
          key: grupo.titulo
        }, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(grupo.titulo), 1),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grupo.skills, (skill) => {
              return (_openBlock(), _createElementBlock("div", {
                key: skill.name
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(skill.name), 1),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(skill.nivel), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", {
                    class: "absolute inset-y-0 left-0 bg-indigo2 h-[3px] -top-[1px]",
                    style: _normalizeStyle({ width: skill.pct + '%' })
                  }, null, 4)
                ])
              ]))
            }), 128))
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})